<div *ngIf="user?.status !== possibleStatuses.ok" class="crm-field-info-view">
  <mat-icon #crmUserTooltip="matTooltip"
            [matTooltip]="possibleMessages[user?.status]"
            matTooltipPosition="below">
    error_outline
  </mat-icon>
</div>
